<template>
  <div id="ExhibitionMobile" class="car-show">
<!--    视频弹框-->
    <div class="video-wrapper" @click="videoShow = false" v-if="videoShow">
      <img src="../../assets/exhibition-sh/carShow/btn-close-m.png" alt="">
      <video height="195" controls autoplay>
        <source :src="playUrl" type="video/mp4">
      </video>
    </div>
    <div class="video-wrapper" @click="show = false" v-if="show">
      <img src="../../assets/exhibition-sh/carShow/btn-close-m.png" alt="">
      <div>
        <img :src="imgUrl" style="width: 100%;height: 100%;margin: 0px;">
      </div>
    </div>
<!-- banner图片-->
    <img src="../../assets/exhibition-sh/carShow/kv-m.png" alt="" class="banner">
<!-- 文章-->
    <section class="article">
      <div @click="handleDetail('https://www.csvw.com/csvw-website/news/company-news.html?newsid=3012')">
        <img src="../../assets/exhibition-sh/carShow/tu1-m.png" alt="" class="banner" >
        <div class="show-h1">新品牌、新产品、新模式 上汽大众携三大品牌亮相2021上海车展</div>
        <div class="show-h2">
          4月19日，2021上海车展如约开幕，上汽大众携三大品牌共同亮相国家会展中心（上海）5.1号馆与3号馆，以新品牌、新产品、新模式，为消费者带来缤纷看点。
        </div>
      </div>
      <div style="margin-top: 35px">
        <div class="article-item" v-for="(item,index) in articles" :key="index" @click="handleDetail(item.url)">
          <img class="img" :src="item.imgUrl" alt="">
          <div class="detail">
            <div class="show-h3">{{item.title}}</div>
<!--            <div class="show-h2">{{item.detail}}</div>-->
          </div>
        </div>
      </div>
    </section>
<!-- 亮点车型-->
    <section class="hight-car">
        <div class="show-h5">亮点车型</div>
        <div class="hight-item"  v-for="(item,index) in hightList" :key="index"
             :style="{backgroundImage:'url('+item.bgUrl+')'}">
          <div class="content">
            <div class="show-h4">{{item.title}}</div>
            <div class="blue-border"></div>
            <div style="margin-top: 8px" class="show-h6">{{item.detail}}</div>
            <div class="btn-wrapper">
              <span class="detail-btn" @click="handleDetail(item.detailUrl)"></span>
              <span class="car-btn" @click="handlePlay(item.videourl)"></span>
            </div>
          </div>
        </div>
    </section>
<!-- 现场花絮-->
    <section class="live-wrapper">
      <div class="show-h5" style="margin-top: 33px">现场花絮</div>
      <div class="radio-wrapper" style="margin-top: 29px;">
          <div class="radio-group">
          <span @click="liveActive = item.key" :class="{'is-active': liveActive === item.key}" class="radio-button" v-for="item in liveBtns" :key="item.key">{{item.value}}</span>
          </div>
      </div>
      <div style="margin-top: 25px">
        <el-carousel arrow="always" indicator-position="none" type="card" height="125px" :autoplay="false">
          <el-carousel-item v-for="item in images" :key="item">
            <img @click="previewImg(item)" class="swiper-item" :src="item" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
    </section>
<!-- 新车赏析-->
    <section>
      <div class="show-h5" style="margin-top: 49px">新车赏析</div>
      <div class="new-radio-box"  style="margin-top: 30px">
        <div class="new-radio-wrapper" id="new-radio-wrapper">
          <div class="new-radio-group">
            <span @click="newActive = item.key" :class="{'is-active': newActive === item.key}" class="radio-button" v-for="item in newBtns" :key="item.key">{{item.value}}</span>
          </div>
        </div>
      </div>
      <div class="news-wrapper">
        <mt-swipe class="news-swipe"  :showIndicators="false" :auto="0">
          <mt-swipe-item v-for="(item, index) in newsList" :key="index">
            <img width="100%" :src="item.imgurlMobile" alt=""  @click="handleDetail(item.url)">
            <div class="news-content"  @click="handleDetail(item.url)">
              <div class="show-h4">{{item.title}}</div>
              <div class="blue-border"></div>
              <div style="margin-top: 8px" class="show-h2">{{item.content}}</div>
            </div>
          </mt-swipe-item>
        </mt-swipe>
        <div class="new-btns">
          <span><</span>左右滑动查看更多<span>></span>
        </div>
      </div>

    </section>
  </div>
</template>
<script>
  let csvw_url = 'https://www.csvw.com';
  let number3List  = [];
  let number5List  = [];
  for (let i =1;i<61;i++) {
    if (i< 31) {
      number3List.push(require(`../../assets/exhibition-sh/number3/${i}.jpg`))
    }
    number5List.push(require(`../../assets/exhibition-sh/number5/${i}.jpg`))
  }
  let news = [
    [
      {
        title: '网上车市',
        content: 'ID.6 X最大功率为150kW，峰值扭矩为310Nm，动力性能强劲、高效。',
        imgurl: require("../../assets/exhibition-sh/imgs/70/1.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/0/1.png"),
        url: 'https://chejiahao.autohome.com.cn/info/8441528'
      },
      {
        title: '汽场汽车',
        content: 'ID.6 X整车造型的型面饱满有力，线条动感流畅，创新感性的设计元素在匹配电动汽车独有气质的同时，将数字、科技、未来的感觉表现得淋漓尽致。',
        imgurl: require("../../assets/exhibition-sh/imgs/70/2.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/0/2.png"),
        url: 'http://auto.ifeng.com/c/85j0jfZWGqO'
      },
      {
        title: '易车',
        content: 'ID.6 X不仅支持手机远程控制车辆，车主还可以使用智能手表控制车内空调、车辆解锁等功能。',
        imgurl: require("../../assets/exhibition-sh/imgs/70/3.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/0/3.png"),
        url: 'https://news.yiche.com/hao/wenzhang/45574499/'
      },
      {
        title: '水滴汽车',
        content: 'ID.6 X仪表、中央触控、AR-HUD增强现实抬头显示组成的三屏交互架构摒弃了堆砌功能按键的传统交互思路，更具科技感和便利性。',
        imgurl: require("../../assets/exhibition-sh/imgs/70/4.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/0/4.png"),
        url: 'https://baijiahao.baidu.com/s?id=1697630227732780739&wfr=spider&for=pc'
      },
      {
        title: '车业杂谈',
        content: 'ID.6 X贯穿式尾灯是尾部一大亮点，纤细灯带与两侧3D LED灯组自然的衔接，拉宽了尾部视觉宽度。全新扁平化发光LOGO装配在中间，简约纯粹又颇具科技感。',
        imgurl: require("../../assets/exhibition-sh/imgs/70/5.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/0/5.png"),
        url: 'https://www.dongchedi.com/article/6955439282786320904'
      },
      {
        title: '选车网',
        content: 'ID.6 X灯腔内的矩阵LED大灯富有三维变化，车灯整体造型体量感十足，轮廓延伸至车身两侧，与醒目的IQ Light标识相融合，营造出一种蓄势待发的神情。',
        imgurl: require("../../assets/exhibition-sh/imgs/70/6.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/0/6.png"),
        url: 'http://www.chooseauto.com.cn/xinche/guonei/311659.shtml'
      },
      {
        title: '买车网',
        content: 'ID.6 X的多层结构电池包采用4重电芯安全设计，并经过338项电池包安全测试，保障电池包在各种极端工况下的安全。',
        imgurl: require("../../assets/exhibition-sh/imgs/70/7.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/0/7.png"),
        url: 'https://chejiahao.autohome.com.cn/info/8439479'
      },
      {
        title: '汽车消费网',
        content: 'ID.6 X搭载的IQ. Drive L2+级自动驾驶辅助，支持方向盘脱手检测及带Stop & Go自动跟车启停，行车更加智能、安全。',
        imgurl: require("../../assets/exhibition-sh/imgs/70/8.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/0/8.png"),
        url: 'http://inf.315che.com/n/2021_04/2022962/'
      },
      {
        title: '中国网汽车',
        content: 'ID.6 X 30色内饰氛围灯可以无级调节，多层布置让整车氛围更加高级。ID. Light 光语系统还会伴随操作指令进行交互闪烁。',
        imgurl: require("../../assets/exhibition-sh/imgs/70/9.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/0/9.png"),
        url: 'http://m.gxfin.com/article/auto/default/default/2021-04-25/712193.html'
      },
      {
        title: '华龙汽车',
        content: 'ID.6 X搭载了上汽大众最新一代智慧车联系统，结合上汽大众超级APP，让车主畅享包含智慧导航、智联控车、智享娱乐、智能家居、智能音箱等一系列在线服务。',
        imgurl: require("../../assets/exhibition-sh/imgs/70/10.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/0/10.png"),
        url: 'http://car.cqnews.net/html/2021-04/19/content_51316356.html'
      },
      {
        title: '汽车焦点',
        content: 'ID.6 X贯通式仪表台设计与多处悬浮式设计的应用，视觉上拉宽内饰空间效果的同时，层次感也更加丰富。',
        imgurl: require("../../assets/exhibition-sh/imgs/70/11.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/0/11.png"),
        url: 'http://www.mycar58.com/xinche/31642.html'
      },
      {
        title: '侃车e族',
        content: 'ID.6 X车长4876mm、宽1848mm、高1680mm，轴距长达2965mm，提供6座/7座选择，空间阔绰，布局灵活。',
        imgurl: require("../../assets/exhibition-sh/imgs/70/12.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/0/12.png"),
        url: 'https://www.maiche.com/news/detail/2409062.html'
      },
      // {
      //   title: '功夫汽车',
      //   content: 'ID.6 X的全视野景观天幕和可开启全景天窗为驾乘人员在视觉上提供了通透的景观空间。',
      //   imgurl: require("../../assets/exhibition-sh/imgs/70/13.png"),
      //   imgurlMobile: require("../../assets/exhibition-sh/news/0/13.png"),
      //   url: 'http://www.gongfuauto.cn/a/6183.html'
      // },
    ],
    [
      {
        title: '汽车之家',
        content: '全新途昂提供第三代EA888 2.0T低碳版/高功版涡轮增压发动机与DQ501 DSG 7速湿式双离合变速器的黄金动力组合，带来澎湃动力性能。',
        imgurl: require("../../assets/exhibition-sh/imgs/71/1.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/1/1.png"),
        url: 'https://www.autohome.com.cn/advice/202104/1140541.html#p1'
      },
      {
        title: '华龙汽车',
        content: '全新途昂搭载智慧车联系统，带来更加高效、数字化的驾乘新体验。',
        imgurl: require("../../assets/exhibition-sh/imgs/71/2.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/1/2.png"),
        url: 'http://car.cqnews.net/html/2021-04/19/content_51316356.html'
      },
      {
        title: '头号汽车',
        content: '全新途昂IQ.Light尊贵迎宾仪式，在靠近/远离车辆时，大灯与尾灯会有迎宾唤醒光效或离车休眠光效的动态效果。',
        imgurl: require("../../assets/exhibition-sh/imgs/71/3.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/1/3.png"),
        url: 'http://www.touhao8.com/index?article_id=1842'
      },
      {
        title: '车生活',
        content: '全新途昂采用悬浮式中控交互屏设计，辅以双层中央控制台及可调式氛围灯及环绕饰板，打造立体悬浮科技氛围。',
        imgurl: require("../../assets/exhibition-sh/imgs/71/4.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/1/4.png"),
        url: 'https://www.cheshenghuo.com/news/17438.html'
      },
      {
        title: '侃车e族',
        content: '全新途昂运用横贯式发光前格柵与LOGO，硬核SUV的气势磅礴基调即刻展现。',
        imgurl: require("../../assets/exhibition-sh/imgs/71/5.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/1/5.png"),
        url: 'https://news.yiche.com/hao/wenzhang/45573037/'
      },
      {
        title: '车一圈',
        content: '全新途昂配备了智能四驱系统、全路况多重驾驶模式选择，能够轻松应对各种复杂路况。',
        imgurl: require("../../assets/exhibition-sh/imgs/71/6.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/1/6.png"),
        url: 'https://www.toutiao.com/i6952853710250836516/?tt_from=weixin&utm_campaign=client_share&wxshare_count=1&timestamp=1618927517&app=news_article&utm_source=weixin&utm_medium=toutiao_ios&use_new_style=1&req_id=202104202205170101351550314A034EB0&share_token=A8DA7B71-7ED3-4126-A16C-F9CA706ED49C&group_id=6952853710250836516'
      },
      {
        title: '白日梦车',
        content: '全新途昂有30色环境氛围灯豪华套装、哈曼卡顿高级音响，搭配12英寸智能多媒体交互系统，豪华的科技氛围无处不在。',
        imgurl: require("../../assets/exhibition-sh/imgs/71/7.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/1/7.png"),
        url: 'https://www.toutiao.com/i6953163552446349863/'
      },
      // {
      //   title: '功夫汽车',
      //   content: '全新途昂全新应用的IQ.Light全LED矩阵式前大灯通过采集实时车速和雨刮信号来自动调整大灯照射的光型，智能实现多种照明模式。',
      //   imgurl: require("../../assets/exhibition-sh/imgs/71/8.png"),
      //   imgurlMobile: require("../../assets/exhibition-sh/news/1/8.png"),
      //   url: 'http://www.gongfuauto.cn/a/6183.html'
      // }
    ],
    [
      // {
      //   title: '太平洋汽车',
      //   content: '全新途昂X的中控台运用镂空式设计，采用拨片式数字换挡方式，增添了科技感与档次感。',
      //   imgurl: require("../../assets/exhibition-sh/imgs/72/1.png"),
      //   imgurlMobile: require("../../assets/exhibition-sh/news/2/1.png"),
      //   url: 'https://cpu.baidu.com/detail/50749900639522401/news'
      // },
      {
        title: '云堆汽车',
        content: '全新途昂X运用了R-Line套件，内嵌高光黑装饰的R-Line特殊前保险杠，搭配底部贯穿两侧的镀铬饰条，进一步强调了横向的视觉感受，也让前脸更具气吞山河的霸气。',
        imgurl: require("../../assets/exhibition-sh/imgs/72/2.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/2/2.png"),
        url: 'https://www.qctt.cn/news/979980'
      },
      {
        title: '一号汽车网',
        content: '全新途昂X的横向进气格栅与两侧大灯视觉上连为一体，秉承家族化特征，新车气势磅礴基调即刻展现。',
        imgurl: require("../../assets/exhibition-sh/imgs/72/3.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/2/3.png"),
        url: 'http://www.yidianzixun.com/article/0TtVZZ4Q'
      },
      {
        title: '有点车事',
        content: '全新途昂X采用全新一代上汽大众智慧车联系统、多元操作方式，带来清晰、顺畅的智能出行体验。',
        imgurl: require("../../assets/exhibition-sh/imgs/72/4.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/2/4.png"),
        url: 'https://www.toutiao.com/w/i1697527122248707/'
      },
      {
        title: '座驾参谋',
        content: '全新途昂X 10.2英寸全液晶数字仪表、12英寸多点触控液晶中控屏组成的三位一体的虚拟显示系统，集成更多功能，让车辆信息清晰可读，增添驾驶舱的科幻感。',
        imgurl: require("../../assets/exhibition-sh/imgs/72/5.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/2/5.png"),
        url: 'https://news.yiche.com/hao/wenzhang/45611785/'
      },
      {
        title: '车生活',
        content: '全新途昂X R-Line特殊后保险杠带高光下扰流板及中块反射片的设计非常有新意，让原本宽厚强健的尾部多了几分动感时尚气息。',
        imgurl: require("../../assets/exhibition-sh/imgs/72/6.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/2/6.png"),
        url: 'https://www.cheshenghuo.com/news/17439.html'
      },
      {
        title: '有车CLUB',
        content: '全新途昂X搭载大众的型号为EA888的2.0T高/低功率发动机，其中330TSI车型发动机最大功率186马力，峰值扭矩320牛·米；380TSI车型发动机最大功率为220马力，峰值扭矩350牛·米。',
        imgurl: require("../../assets/exhibition-sh/imgs/72/7.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/2/7.png"),
        url: 'http://cj.sina.com.cn/articles/view/6301469426/17798caf200100xuts'
      },
      {
        title: '汽车消费网',
        content: '全新途昂X的21寸黑色轮毂搭配红色刹车卡钳，给人强烈的视觉冲击，强化了整车的运动感。',
        imgurl: require("../../assets/exhibition-sh/imgs/72/8.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/2/8.png"),
        url: 'http://inf.m.315che.com/n/2021_04/2022797/'
      },
    ],
    [
      {
        title: '汽车之家',
        content: '全新奥迪A7L配置 48V 轻混系统，全面电气化加持，制动时提供能量回收并用于加速，动力更强劲、乘坐更舒适。',
        imgurl: require("../../assets/exhibition-sh/imgs/73/1.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/3/1.png"),
        url: 'https://chejiahao.autohome.com.cn/info/8465556#pvareaid=6826274'
      },
      {
        title: '车界微视',
        content: '全新奥迪A7L通过奥迪专属个性化账号，上车后即可自动将电动方向盘、电动座椅和外后视镜等调整到预设角度。',
        imgurl: require("../../assets/exhibition-sh/imgs/73/2.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/3/2.png"),
        url: 'https://www.toutiao.com/i6952870976073826824/?tt_from=weixin&utm_campaign=client_share&wxshare_count=1&timestamp=1618843076&app=news_article&utm_source=weixin&utm_medium=toutiao_ios&use_new_style=1&req_id=202104192237560101512042173E1294DE&share_token=D815BDD5-2F17-4633-8DC5-435A2DE5AB77&group_id=6952870976073826824'
      },
      {
        title: '白日梦车',
        content: '全新奥迪A7L行驶中可根据车速、驾驶模式、路况，自动调节车身高度，向下达10mm，向上达20mm，哪怕前路多变，亦稳稳通过。',
        imgurl: require("../../assets/exhibition-sh/imgs/73/3.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/3/3.png"),
        url: 'https://news.yiche.com/hao/wenzhang/45554898/'
      },
      {
        title: '玩车教授',
        content: '全新奥迪A7L向奥迪历史经典车型 Ur-quattro 致敬，13个 LED 垂直光段组成尾部纤细光带，传承奥迪顶级车型共有的风格魅力。',
        imgurl: require("../../assets/exhibition-sh/imgs/73/4.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/3/4.png"),
        url: 'https://baijiahao.baidu.com/s?id=1698294878175314102&wfr=spider&for=pc'
      },
      {
        title: '头号汽车',
        content: '全新奥迪A7L彩色的车辆信息、道路标识、导航信息，都直观清晰地显示在正前方，驾驶员目光可始终专注于前方路面，行车更安全。',
        imgurl: require("../../assets/exhibition-sh/imgs/73/5.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/3/5.png"),
        url: 'http://www.touhao8.com/index?article_id=1823'
      },
      {
        title: '座驾参谋',
        content: '全新奥迪A7L带 5G 高速传输通信模块的智慧城市互联技术，可实现 V2V、V2N 通信，实现多项安全预警及绿波车速引导。',
        imgurl: require("../../assets/exhibition-sh/imgs/73/6.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/3/6.png"),
        url: 'https://chejiahao.autohome.com.cn/info/8395409?r=20210419154909'
      },
      // {
      //   title: '功夫汽车',
      //   content: '全新奥迪A7L 12.3英寸高分辨率 TFT 屏幕，位于驾驶员视线正前方，多项驾驶信息，排列简单易懂、一目了然。',
      //   imgurl: require("../../assets/exhibition-sh/imgs/73/7.png"),
      //   imgurlMobile: require("../../assets/exhibition-sh/news/3/7.png"),
      //   url: 'http://www.gongfuauto.cn/a/6181.html'
      // },
      {
        title: '云堆汽车',
        content: '全新奥迪A7L下车后，在人车距离6米内，长按手机 APP 泊车键，即可实现垂直车位的自动泊出、泊入和转向功能。',
        imgurl: require("../../assets/exhibition-sh/imgs/73/8.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/3/8.png"),
        url: 'https://www.qctt.cn/news/979969'
      },
      {
        title: '穹眼财经',
        content: '全新奥迪A7L四个摄像头，全方位显示车辆四周全景图，配合中央驾驶辅助控制系统，持续计算周围环境图像。',
        imgurl: require("../../assets/exhibition-sh/imgs/73/9.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/3/9.png"),
        url: 'https://m.sohu.com/a/462371908_329297/?pvid=000115_3w_a'
      },
      {
        title: '球叔教你买车',
        content: '全新奥迪A7L 5076mm的车身长度和3026mm的长轴距，优雅灵动的线条和低趴车身姿态，实现了乘坐空间、造型美感的完美融合。',
        imgurl: require("../../assets/exhibition-sh/imgs/73/10.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/3/10.png"),
        url: 'https://news.yiche.com/hao/wenzhang/45521949/'
      },
      {
        title: 'EV世纪-EV君',
        content: '全新奥迪A7L无框车门保留了轿跑的设计元素，经典又充满运动感。配置电吸门功能，车门半锁即可正常工作。',
        imgurl: require("../../assets/exhibition-sh/imgs/73/11.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/3/11.png"),
        url: 'http://www.21cnev.com/html/202104/787743_1.html'
      },
      // {
      //   title: 'Report汽车',
      //   content: '全新奥迪A7L Bang&Olufsen 3D 环绕沉浸式音响系统，拥有16个扬声器，包括高音及中置扬声器与低音炮，无论坐在哪一排，都如置身音乐会前排。',
      //   imgurl: require("../../assets/exhibition-sh/imgs/73/12.png"),
      //   imgurlMobile: require("../../assets/exhibition-sh/news/3/1.png"),
      //   // url: 'http://www.reportauto.cn/f/view-28-3114.html'
      // },
    ],
    [
      {
        title: '汽车之家',
        content: '全新明锐PRO全系标配1.4TSI高功率发动机、最大扭矩250N.m，兼具澎湃的动力体验与优秀的燃油经济性。',
        imgurl: require("../../assets/exhibition-sh/imgs/74/1.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/4/1.png"),
        url: 'https://www.autohome.com.cn/news/202104/1145407.html#pvareaid=2023650'
      },
      {
        title: '网上车市',
        content: '全新明锐PRO配备了同级罕有的电子排挡，不仅操作便捷，也更加节省空间。',
        imgurl: require("../../assets/exhibition-sh/imgs/74/2.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/4/2.png"),
        url: 'https://chejiahao.autohome.com.cn/info/8482131#pvareaid=6826274'
      },
      {
        title: '易车',
        content: '全新明锐PRO的T型中控台布局整齐有序，悬浮式中控屏和“911同款”的电子挡杆大大提升了科技感。',
        imgurl: require("../../assets/exhibition-sh/imgs/74/3.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/4/3.png"),
        url: 'https://news.yiche.com/xinchexiaoxi/20210428/2114449083.html'
      },
      {
        title: '水滴汽车',
        content: '全新明锐PRO现代化的智能辅助驾驶设备，比如毫米波雷达探头和前视摄像头，都将隐藏在斯柯达品牌经典的格栅之内。',
        imgurl: require("../../assets/exhibition-sh/imgs/74/4.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/4/4.png"),
        url: 'https://chejiahao.autohome.com.cn/info/8478117#pvareaid=6826274'
      },
      {
        title: '白日梦车',
        content: '全新明锐PRO采用全新MQB EVO数字智能架构，全车15个超声波、毫米波雷达，以及5个摄像头，打造全新升级的德系数字科技体验。',
        imgurl: require("../../assets/exhibition-sh/imgs/74/5.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/4/5.png"),
        url: 'https://aikahao.xcar.com.cn/item/772451.html'
      },
      {
        title: '华龙汽车',
        content: '全新明锐PRO全面升级，4753mm/1832mm/1469mm的长宽高（含外饰件），以及2730mm的车身轴距。',
        imgurl: require("../../assets/exhibition-sh/imgs/74/6.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/4/6.png"),
        url: 'http://car.cqnews.net/html/2021-04/19/content_51316393.html'
      },
      {
        title: '头号汽车网',
        content: '全新明锐PRO实现了集按键、手势、触控、语音在内的多元操控形式，可以带来更为便捷的交互体验。',
        imgurl: require("../../assets/exhibition-sh/imgs/74/7.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/4/7.png"),
        url: 'http://www.touhao8.com/index?article_id=1843'
      },
      {
        title: '车生活',
        content: '全新明锐PRO搭载斯柯达智慧车联系统的车型，配合斯柯达超级APP，拥有智能语音、智慧导航、智享娱乐、智趣出行、智联控车5大核心功能。',
        imgurl: require("../../assets/exhibition-sh/imgs/74/8.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/4/8.png"),
        url: 'https://www.cheshenghuo.com/news/17436.html'
      },
      {
        title: '汽车葫芦圈',
        content: '全新明锐PRO内饰材质上选择众多软性包覆材质，在中控区和门板处均采用软性皮质材料及同色缝线，中控区更是使用带有碳纤维纹理的Carbon材质包覆，内饰质感大幅提升。',
        imgurl: require("../../assets/exhibition-sh/imgs/74/9.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/4/9.png"),
        url: 'https://www.toutiao.com/i6953517766104236576'
      },
      {
        title: '汽车焦点',
        content: '全新明锐PRO很巧妙地将掀背、溜背结合起来，与水晶设计架构的元素形成共振，营造出了不逊于“轿跑家用车”的运动范儿。',
        imgurl: require("../../assets/exhibition-sh/imgs/74/10.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/4/10.png"),
        url: 'http://www.mycar58.com/xinche/31793.html'
      },
      // {
      //   title: '功夫汽车',
      //   content: '全新明锐PRO全新设计的立体垂瀑式格栅造型年轻犀利，发动机盖上的立体棱线营造出三维立体雕塑感。',
      //   imgurl: require("../../assets/exhibition-sh/imgs/74/11.png"),
      //   imgurlMobile: require("../../assets/exhibition-sh/news/4/11.png"),
      //   url: 'http://www.gongfuauto.cn/a/6182.html'
      // },
      {
        title: '中国经济新闻网',
        content: '全新明锐PRO采用了大掀背设计，不仅后备厢容积表现出色，其后排乘坐空间并没有丝毫“缩水”。',
        imgurl: require("../../assets/exhibition-sh/imgs/74/12.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/4/12.png"),
        url: 'http://www.cet.com.cn/wzsy/ycxw/2829297.shtml'
      },
      {
        title: '阿贵看车',
        content: '全新明锐PRO全系标配全新升级的后独立悬挂，该悬挂采用四连杆结构，可分解横向和纵向受力，带来更好的操控体验。',
        imgurl: require("../../assets/exhibition-sh/imgs/74/13.png"),
        imgurlMobile: require("../../assets/exhibition-sh/news/4/13.png"),
        url: 'https://www.toutiao.com/i6953250474166551051/'
      },
    ]
  ];
  export default {
  data() {
    return {
      show: false,
      playUrl: '',
      imgUrl: '',
      index: 0,
      videoShow: false,
      newActive: '1',
      images: number3List,
      newsList: news[0],
      newBtns: [
        {
          key: '1',
          value: 'ID.6 X'
        },
        {
          key: '2',
          value: '全新途昂'
        },
        {
          key: '3',
          value: '全新途昂X'
        },
        {
          key: '4',
          value: '全新奥迪A7L'
        },
        {
          key: '5',
          value: '全新明锐PRO'
        }
      ],
      liveActive: '1',
      liveBtns: [
        {
          key: '1',
          value: '3号馆'
        },
        {
          key: '2',
          value: '5.1号馆'
        }
      ],
      hightList: [
        {
          bgUrl: require('../../assets/exhibition-sh/carShow/tu5-m.png'),
          detailUrl: 'https://www.csvw.com/svwmedia-website/media/teramont.html?contentId=24967',
          title: 'ID.6 X',
          videourl: csvw_url + "/u/cms/www/202104/27153247ydRT.mp4",
          detail: 'ID.6 X是一款打造品质标杆的七座智能纯电SUV，ID.6 X秉持大众品牌电动车家族的设计语言，是上汽大众电动SUV家族的领航者。'
        },
        {
          bgUrl: require('../../assets/exhibition-sh/carShow/tu6-m.png'),
          title: 'All New Teramont 全新途昂',
          videourl: csvw_url + "/u/cms/www/202104/261457040660.mp4",
          detailUrl: 'https://www.csvw.com/svwmedia-website/activities/detail.html?contentId=24988',
          detail: 'All New Teramont全新途昂是上汽大众旗舰全尺寸七座SUV，它不仅丰富了上汽大众在SUV细分市场的产品阵容，还与PHIDEON辉昂、Viloran威然一同构建起上汽大众高端产品阵营。'
        },
        {
          bgUrl: require('../../assets/exhibition-sh/carShow/tu7-m.png'),
          title: 'All New Teramont X 全新途昂X',
          videourl: csvw_url + "/u/cms/www/202104/26145737R036.mp4",
          detailUrl: 'https://www.csvw.com/svwmedia-website/activities/detail.html?contentId=24989',
          detail: '大众品牌旗舰豪华运动SUV全新途昂X以新造型旗舰设计、大格局数字空间、强安全行车科技、超智能交互科技、全路况操控性能，开拓全新的SUV细分场。'
        },
        {
          bgUrl: require('../../assets/exhibition-sh/carShow/tu8-m.png'),
          title: 'All New Audi A7L 全新奥迪A7L',
          videourl: csvw_url + "/u/cms/www/202104/26145739K8ue.mp4",
          detailUrl: 'https://saic-audi.audibrand.cn/zh/models/a/all_new_a7l.html',
          detail: '2021年4月18日，上汽奥迪带来了首款C+级性能行政车型——全新奥迪A7L的全球首秀。承袭了奥迪品牌的经典基因和领先技术，全新奥迪A7L将运动性与舒适性完美结合，既能够满足精英人士对商务格调的品味要求，又紧密贴合了新世代凌厉动感的审美趋势。'
        },
        {
          bgUrl: require('../../assets/exhibition-sh/carShow/tu9-m.png'),
          title: 'OCTAVIA PRO 全新明锐PRO',
          videourl: csvw_url + "/u/cms/www/202104/26145739437C.mp4",
          detailUrl: 'https://www.csvw.com/svwmedia-website/media/teramont.html?contentId=24936',
          detail: '全新明锐PRO，是首款采用全新MQB EVO数字智能架构的斯柯达车型，依托全方位领先的八大PRO亮点以及诚意满满的价格，全力出击A+级轿车市场。'
        }
      ],
      articles: [
        {
          imgUrl: require('../../assets/exhibition-sh/carShow/tu2-m.png'),
          title: '新车投放提速 上汽大众ID.6 X、全新途昂家族联袂亮相上海车展',
          url: 'https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=3007',
          detail: '今年一季度，上汽大众大众品牌累计终端交付368,344辆，同比上年增幅达到67%，实力问鼎单一品牌销... 冠军。'
        },
        {
          imgUrl: require('../../assets/exhibition-sh/carShow/tu3-m.png'),
          title: '驾驭时代，承启未来，上汽奥迪携旗舰车型闪耀亮相2021上海车展',
          url: 'https://www.csvw.com/csvw-website/news/company-news.html?newsid=3005',
          detail: '“环形‘家’年华”2021上汽奥迪粉丝主题活动在上海举行。100位四环粉丝相聚申城，共赴上汽奥迪首场触动心灵的家宴之旅。“以用户为核心”是上汽奥迪产品创新、用户运营的基本信条。在品牌建设和产品研发初期，上汽奥迪与车主进行了深入沟通，并通过实体体验、用户意见参考、中国消费者驾驶和乘坐习惯分析，全面挖掘新时代中国消费者对豪华品牌的真是需求。活动现场，车主代表分享了自己与四环品牌的故事。奥迪对他们的意义远超过代步工具，而是变成了生活中的亲密伙伴，成为信仰的支撑。活动当天，上汽奥迪还“官宣”了首批全新奥迪A7L体验官。他们将从车主身份提出合理建议，帮助上汽奥迪更好的对用户需求进行深层理解及思考，位产品和服务加成。上汽奥迪将携手更多用户，共同见证四环品牌每一次突破、每一份创想。'
        },
        {
          imgUrl: require('../../assets/exhibition-sh/carShow/tu4-m.png'),
          title: '全新明锐PRO公众首秀  斯柯达携焕新阵容出击2021上海车展',
          url: 'https://www.csvw.com/csvw-website/news/skoda-brand-news.html?newsid=3004',
          detail: '4月19日，第十九届上海国际汽车工业展览会即将拉开帷幕。上汽大众斯柯达全新明锐A8即将亮相斯柯...达展台。柯迪亚克家族2021款... 款...............2021款速派、柯珞克、柯米克GT等颜值实力兼具的车型将一同亮相上海国家会展中心5.1号馆斯柯达展台。'
        }
      ]
    };
  },
  watch: {
    show() {
      document.body.style.overflow = this.show ? 'hidden':'auto';
    },
    videoShow() {
      document.body.style.overflow = this.videoShow ? 'hidden':'auto';
    },
    liveActive() {
     this.images =  (this.liveActive == 1 ?  number3List : number5List)
    },
    newActive() {
      let n = parseInt(this.newActive);
      this.newsList = news[n - 1];
      switch (n) {
        case 2:
          document.getElementById('new-radio-wrapper').scrollLeft= 0;
          break;
        case 3:
          document.getElementById('new-radio-wrapper').scrollLeft= 120;
          break;
        case 4:
          document.getElementById('new-radio-wrapper').scrollLeft= 242;
          break;
      }
    }
  },
  mounted() {

  },
  methods: {
    scrollHandle(e) {
      console.log(e)
    },
    previewImg(url) {
      this.show = true;
      this.imgUrl = url;
    },
    handlePlay(url) {
      if (!url) return;
      this.playUrl = url;
      this.videoShow = true;
    },
    handleDetail(url) {
      if (!url) return;
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="less">

  .car-show {
    .news-swipe {
      height: 340px;
    }
    .swiper-item {
      display: block;
      width: 100%;
      height: 100%;
    }
    .video-wrapper {
      top: 0;
      z-index: 9999;
      position: fixed;
      width: 100%;
      height: 100%;
      display:flex;
      flex-direction:column;
      align-items:center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.7);
      padding: 0 15px;
      box-sizing: border-box;
      img {
        width: 18px;
        height: 18px;
        display: block;
        margin-left: calc(100% - 18px);
        margin-bottom: 10px;
      }
      video {
        width: 100%;
      }
    }

    .el-carousel__arrow {
      width: 17px;
      height: 20px;
      background: #000000;
      opacity: 0.7;
      border-radius: 2px;
    }
    .radio-wrapper {
      width: 100%;
      display: flex;
      justify-content: center;
    }
    .new-radio-box {
      width: 100%;
      height: 32px;
      overflow: hidden;
    }
    .new-radio-wrapper {
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
      height: 42px;
      padding: 0 15px;
      box-sizing: border-box;
      transition: all .5s;
      /*&::-webkit-scrollbar {*/
      /*  width: 0px;*/
      /*  height: 0px;*/
      /*}*/
    }
    .new-radio-group {
      width: 600px;
      height: 45px;
      transition: all .5s;
    }
    .radio-group, .new-radio-group {
      height: 30px;
      box-shadow: 0px 2px 4px 0px rgba(93, 129, 244, 0.54);
      border: 1px solid #8FA9FC;
      border-radius: 3px;
      overflow: hidden;
      .radio-button {
        box-shadow: 0px 2px 4px 0px rgba(93, 129, 244, 0.54);
        display: inline-block;
        width: 120px;
        height: 30px;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        line-height: 30px;
        color: #8FA9FC;
        cursor: pointer;
        border-right: 1px solid #8FA9FC;
        box-sizing: border-box;
        &.is-active {
          background: #8FA9FC;
          color: #fff;
        }
        &:nth-last-child(1) {
          border: none;
        }
      }
    }
    .news-wrapper {
      width: 100%;
      height: 426px;
      background: url("../../assets/exhibition-sh/carShow/bg-m.png");
      background-size: 100% 100%;
      padding: 20px 15px;
      box-sizing: border-box;
      margin-top: 25px;
      .news-content {
        background: white;
        width: 100%;
        height: 136px;
        box-sizing: border-box;
        padding: 19px 15px;
      }
      .new-btns {
        color: white;
        font-size: 12px;
        text-align: center;
        margin-top: 20px;
        span {
          font-size: 14px;
          margin: 0 13px;
        }
      }
    }
  }
</style>
<style lang="less" scoped>
  .show-h1 {
    font-weight: bold;
    font-size: 13px;
    line-height: 22px;
    margin-top: 26px;
  }
  .show-h3 {
    font-weight: bold;
    font-size: 12px;
    line-height: 20px;
  }
  .show-h4 {
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
  }
  .show-h5 {
    font-weight: bold;
    font-size: 22px;
    line-height: 20px;
    text-align: center;
    margin: 10px 0 28px 0;
  }
  .show-h2 {
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    overflow:hidden;//将超出的部分隐藏
    text-overflow:ellipsis;//超出部分用省略号显示
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
    margin-top: 14px;
  }
  .show-h6 {
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    margin-top: 14px;
  }
  .car-show {
    font-family: "Microsoft Yahei", "微软雅黑";
    color: #333;
    box-sizing: border-box;
    img {
      display: block;
    }
    .banner {
      width: 100%;
    }
    .article {
      padding: 50px 15px;
      .article-item {
         padding: 15px 0;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        border-bottom: 1px solid #f1f1f1;
        .img {
          width: 120px;
          height: 90px;
          display: block;
        }
        .detail {
          flex: 1;
          padding-left: 13px;
        }
      }
    }
    .hight-item {
      width: 100%;
      height: 372px;
      background-size: 100% 100%;
      position: relative;
      margin-bottom: 20px;
      .content {
        position: absolute;
        bottom: 0px;
        left: 15px;
        right: 15px;
      }
      &:nth-child(5) {
        margin-bottom: 52px;
        .content {
          bottom: -32px;
        }
      }
    }
    .blue-border {
      width: 20px;
      height: 3px;
      background: #5F84FC;
      margin-top: 8px;
    }
    .btn-wrapper {
      margin-top: 18px;
      span {
        display: inline-block;
        width: 112px;
        height: 28.5px;
        cursor: pointer;
      }
      .detail-btn {
        background: url("../../assets/exhibition-sh/carShow/btn1-m.png") 100% 100%;
        background-size: 100% 100%;
      }
      .car-btn {
        margin-left: 29.5px;
        background: url("../../assets/exhibition-sh/carShow/btn2-m.png") 100% 100%;
        background-size: 100% 100%;
      }
    }
  }

</style>
